var map = {
	"./ActionsDialog.vue": "1cf4",
	"./ApprovalRequestCard.vue": "0b6c",
	"./BuscarContatoMarca.vue": "c506",
	"./CadastrarTarefa.vue": "ac74",
	"./Carousel.vue": "3693",
	"./CarouselActionButtons.vue": "1281",
	"./CarrinhosAbandonados.vue": "5e78",
	"./ChangeStoreDialog.vue": "a650",
	"./DashboardGestor/DashboardCampaignData.vue": "543c",
	"./DashboardGestor/DashboardCampaignProgress.vue": "9e18",
	"./DashboardGestor/DashboardCampaignResultDialog.vue": "cf28",
	"./DashboardGestor/DashboardCampaigns.vue": "34bc",
	"./DashboardGestor/DashboardData.vue": "e3f1",
	"./DashboardGestor/DashboardGraph.vue": "401b",
	"./DashboardGestor/DashboardGraphBar.vue": "07a8",
	"./DashboardGestor/DashboardHeader.vue": "9912",
	"./DashboardGestor/DashboardShopsGraph.vue": "846f",
	"./DashboardGestor/DashboardShopsStats.vue": "c485",
	"./DashboardGestor/DashboardStatistics.vue": "113a",
	"./DashboardGestor/DashboardStoreExpansionalPanel.vue": "5c82",
	"./DashboardGestor/DashboardStoreSelect.vue": "d118",
	"./DetalhesTarefasModal.vue": "2b0e9",
	"./FilterBy.vue": "2d2e",
	"./Footer.vue": "fd2d",
	"./Header.vue": "0418",
	"./HistoricoPedidos.vue": "7238",
	"./IdentifyPersonDialog.vue": "69f0",
	"./ListaContatos.vue": "ea9d",
	"./Loader.vue": "555f",
	"./Login.vue": "578a",
	"./Notifications.vue": "e985",
	"./OrderCard.vue": "5e86",
	"./Product/ApprovalRequestDialog.vue": "7bfb",
	"./Product/BarCodeDialog.vue": "40f1",
	"./Product/CartProduct.vue": "0330",
	"./Product/DeclinedApprovalProduct.vue": "233e",
	"./Product/ProductCard.vue": "2bd5",
	"./Product/ProductDetailsTabs.vue": "9c24",
	"./Product/ProductEditDialog.vue": "c93e",
	"./Product/ProductInfos.vue": "d507",
	"./Product/RecommendedProduct.vue": "0885",
	"./Product/ReviewCartDialog.vue": "f77f",
	"./Product/ServicesDialog.vue": "17c7",
	"./Product/WarrantyDialog.vue": "424e",
	"./Product/WarrantyMobileDialog.vue": "7b4d",
	"./Product/ZeroStockDialog.vue": "349a",
	"./QrCodeDialog.vue": "c5d6",
	"./RateCampaign.vue": "6f39",
	"./RecuperarSenha.vue": "b69e",
	"./RegistrarComentario.vue": "84c8",
	"./Sellers/EditSellerAltCodeTooltipContent.vue": "80bd",
	"./Sellers/EditSellerBasicInput.vue": "0700",
	"./Sellers/EditSellerCodeTooltipContent.vue": "414d",
	"./Sellers/EditSellerConfirmDialog.vue": "d54e",
	"./Sellers/EditSellerExclusionDialogContent.vue": "76dd",
	"./Sellers/EditSellerHeader.vue": "5f55",
	"./Sellers/EditSellerProfileTooltipContent.vue": "f8dc",
	"./Sellers/EditSellerStoreRemovalDialogContent.vue": "c7c9",
	"./Sellers/EditSellerSuspensionDialogContent.vue": "2596",
	"./Sellers/EditSellerTooltip.vue": "f099",
	"./Sellers/SellersHeader.vue": "74c9",
	"./Sellers/SellersList.vue": "3f0e",
	"./Sellers/SellersStoreSelect.vue": "5cc7",
	"./Signup.vue": "c3f0",
	"./SortBy.vue": "921a",
	"./Suporte.vue": "d33b",
	"./TaskPopOver.vue": "79b0",
	"./TitleChip.vue": "c871",
	"./WelcomeCard.vue": "62e9",
	"./helper/Offset.vue": "c6cc",
	"./icons/alertIcon.vue": "dfa2",
	"./icons/arrowDownIcon.vue": "8ef8",
	"./icons/arrowLeftIcon.vue": "a00e",
	"./icons/arrowRightIcon.vue": "a617",
	"./icons/arrowSwapIcon.vue": "c614",
	"./icons/atSignIcon.vue": "613b4",
	"./icons/bagIcon.vue": "0970",
	"./icons/barCodeIcon.vue": "f744",
	"./icons/barCodeScanner.vue": "d22d",
	"./icons/basketIcon.vue": "fc9b",
	"./icons/blockIcon.vue": "54cb",
	"./icons/cakeIcon.vue": "c7f6",
	"./icons/cartIcon.vue": "b911",
	"./icons/catalogueIcon.vue": "26e8",
	"./icons/catalogueThinIcon.vue": "b80d",
	"./icons/checkIcon.vue": "a848",
	"./icons/circle.vue": "651d",
	"./icons/clockIcon.vue": "6014",
	"./icons/cpfIcon.vue": "130c",
	"./icons/crmLogoIcon.vue": "611f",
	"./icons/deleteIcon.vue": "5736",
	"./icons/doneIcon.vue": "c2c2",
	"./icons/editIcon.vue": "2ecf",
	"./icons/exclamationCircleIcon.vue": "f73a",
	"./icons/gearCheckIcon.vue": "089e",
	"./icons/giftIcon.vue": "d426",
	"./icons/heartEyesIcon.vue": "cbf5",
	"./icons/heartIcon.vue": "bf81",
	"./icons/heartOutlineIcon.vue": "28ed",
	"./icons/houseIcon.vue": "ec4b",
	"./icons/localActivityIcon.vue": "5d6d",
	"./icons/magnifyPlusIcon.vue": "4532",
	"./icons/mailIcon.vue": "8276",
	"./icons/moneyBagIcon.vue": "5684",
	"./icons/moneyCircleIcon.vue": "83d4",
	"./icons/nophoneIcon.vue": "825d",
	"./icons/openBookIcon.vue": "ee13",
	"./icons/pIcon.vue": "ad22",
	"./icons/passwordLockIcon.vue": "3be3",
	"./icons/phoneIcon.vue": "b59a",
	"./icons/scaredEmojiIcon.vue": "5e00",
	"./icons/searchIcon.vue": "a5f7",
	"./icons/sendIcon.vue": "bc13",
	"./icons/shoppingBagIcon.vue": "6819",
	"./icons/signOutIcon.vue": "852e",
	"./icons/sparklesIcon.vue": "c6f0",
	"./icons/storeIcon.vue": "d587",
	"./icons/targetIcon.vue": "9cf5",
	"./icons/unionIcon.vue": "919a",
	"./icons/userCardIcon.vue": "6917",
	"./icons/userIcon.vue": "372f",
	"./icons/userPlusIcon.vue": "4b4b",
	"./icons/winkIcon.vue": "8d53",
	"./icons/zipperLogoIcon.vue": "af9a",
	"./material/Card.vue": "e3a9",
	"./material/StatsCard.vue": "42e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";